import { defineStore } from "pinia";
import documentService from "@/services/Documentet/document.service";


export const useDocumentStore = defineStore("documentStore", {
  state: () => ({
    documentTypeCounts: [],
    loading: false,
    error: null,
    documentet: [],
  }),

  actions: {
    formatDate(dateString) {
      if (!dateString) return "";

      const isoString = dateString.replace(" ", "T").split(".")[0];

      const date = new Date(isoString);
      if (isNaN(date)) return "";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },

    async fetchDocumentTypeCounts() {
      this.loading = true;
      this.error = null;
      try {
        const response = await documentService.getDocumentTypeCounts();
        this.documentTypeCounts = response;
        return response;
      } catch (err) {
        this.error =
          err.response?.data?.message ||
          err.message ||
          "Gabim gjatë marrjes së të dhënave";
      } finally {
        this.loading = false;
      }
    },

    async getDocumentet(docData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await documentService.getDocuments(docData);

        this.documentet = response.map((doc) => ({
          Id: doc.id || doc.Id,
          ProkuroriaId: doc.prokuroriaId,
          CreatedDate: this.formatDate(doc.createdDate) || doc.createdDate,
          EndDate: this.formatDate(doc.endDate) || doc.endDate,
          ParentId: doc.parentId || doc.ParentId || 0,

          Title: doc.title,
          DocumentFileUrl: doc.documentFileUrl
            ? "https://prokuroria-rks.org/uploads/" +
              doc.documentFileUrl
            : null,
          Language: doc.language,
          CategoryIds: doc.CategoryIds,
          PostCategoriesIds: doc.PostCategoriesIds,
          SubCategoriesIds: doc.SubCategoriesIds,
          isParent: doc.isParent || false,
          isChild: doc.isChild || false,
        }));

        return this.documentet;
      } catch (err) {
        this.error = err.message || "Failed to fetch documents";
        console.error("Error fetching documents:", err);
        return [];
      } finally {
        this.loading = false;
      }
    },

    async getDocumentChilde(docData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await documentService.getDocumetChilde(docData);

        return response.map((doc) => ({
          Id: doc.id || doc.Id,
          ProkuroriaId: doc.prokuroriaId,
          CreatedDate: this.formatDate(doc.createdDate) || doc.createdDate,
          EndDate: this.formatDate(doc.endDate) || doc.endDate,
          ParentId: doc.parentId || doc.ParentId || 0,
          Title: doc.title,
          DocumentFileUrl: doc.documentFileUrl
            ? "https://prokuroria-rks.org/uploads/" +
              doc.documentFileUrl
            : null,
          Language: doc.language,
          CategoryIds: doc.CategoryIds,
          PostCategoriesIds: doc.PostCategoriesIds,
          SubCategoriesIds: doc.SubCategoriesIds,
          isParent: doc.isParent || false,
          isChild: doc.isChild || false,
        }));
      } catch (err) {
        this.error = err.message || "Failed to fetch documents";
        console.error("Error fetching documents:", err);
        return [];
      } finally {
        this.loading = false;
      }
    },

    async getYears(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await documentService.getYears(data);
        return response;
      } catch (err) {
        this.error =
          err.response?.data?.message ||
          err.message ||
          "Gabim gjatë marrjes së viteve";
        console.error("Error fetching years:", err);
        return [];
      } finally {
        this.loading = false;
      }
    },
  },
});
